module.exports = __webpack_public_path__ + "8cff11796a8e706afce67c25966e7dae.MP3";